export default {
    Menu: 'Menú',
    Add: 'Añadir',
    Modify: 'Modificar',
    Delete: 'Eliminar',
    Scale: 'Redimensionar',
    Color: 'Color',
    Materials: 'Materiales',
    Mesh: 'Malla',
    Size: 'Tamaño',
    Details: 'Detalles',
    Quantity: 'Cantidad',
    AddToCart: 'Añadir al carrito',
    AddToCartTitle: 'Añadir al carrito',
    Cart: 'Carrito',
    Total: 'Total',
    Subtotal: 'Subtotal',
    Shipping: 'Envío',
    Shape: 'Forma',
    PickShape: 'Elija una forma para añadir al lienzo',
    ShapeAdded: 'Forma añadida. Haga clic en otra para reemplazarla.',
    Clipart: 'Ilustración',
    PickClipart: 'Elija una ilustración para añadir al lienzo',
    ClipartAdded: 'Ilustración añadida. Haga clic en otra para reemplazarla.',
    SearchClipart: 'Buscar una ilustración…',
    NoClipartFound: 'No se encontró ninguna ilustración',
    Cliparts: 'Cliparts',
    Illustration: 'Ilustración',
    AiImage: 'Imagen IA',
    AiImageIntro: 'Describa lo que desea, elija un formato y obtenga 2 propuestas.',
    AiImageFormat: 'Formato',
    AiFormatSquare: 'Cuadrado',
    AiFormatPortrait: 'Vertical',
    AiFormatLandscape: 'Horizontal',
    AiImagePlaceholder: 'Ej.: un zorro rojo estilizado, estilo plano, fondo transparente…',
    AiGenerate: 'Generar',
    AiGenerating: 'Generando…',
    AiPickResult: 'Elija una propuesta',
    AiImageAdded: 'Imagen añadida al lienzo',
    AiImageError: 'Error al generar la imagen',
    AiNoResult: 'No se generó ninguna imagen',
    AiImageNotInPlan: 'La generación de imágenes IA no está incluida en su plan. Active la opción para usarla.',
    SearchIllustration: 'Buscar una ilustración…',
    NoIllustrationFound: 'No se encontró ninguna ilustración',
    IllustrationIntro: 'Busque ilustraciones vectoriales para añadir al lienzo.',
    IllustrationError: 'Error en la búsqueda de ilustraciones',
    IllustrationNotVector: 'Este resultado no es un vector utilizable',
    Texts: 'Textos',
    Images: 'Imágenes',
    Colors: 'Colores',
    ThemeEditDesc: 'Modifique los textos, imágenes y colores del tema.',
    ThemeNotFound: 'Tema no encontrado.',
    ThemeNoEditable: 'Este tema no contiene elementos modificables.',
    Helpers: 'Reglas, guías y cuadrícula',
    Rulers: 'Reglas',
    RulersHint: 'Graduación en píxeles',
    Guides: 'Guías',
    GuidesHint: 'Marcas al 25 / 50 / 75 %',
    GridHint: 'Cuadrícula superpuesta',
    Snapping: 'Ajuste magnético',
    SnappingHint: 'Alinea al centro / cuadrícula / otros objetos',
    LeaveConfirm: '¿Seguro que desea perder sus cambios?',
    Products: 'Productos',
    Customization: 'Personalización',
    BackToCustomizationType: 'Tipo de personalización',
    SaveNoChanges: 'No hay cambios que guardar',
    ChooseCategory: 'Elija una categoría',
    SelectProduct: 'Elija un producto',
    Loading: 'Cargando',
    ProofLogoTooLarge: 'Logo demasiado pesado (máximo 500 KB).',
    ProofLogoInvalidType: 'Formato de imagen no compatible.',
    ProofLogoImported: 'Logo importado.',
    ProofLogoImportFailed: 'Error al importar el logo.',
    YouHaveProjects: 'Tienes {count} proyecto(s) en curso',
    ResumeProject: 'Retomar un proyecto',
    ResumeProjectHint: 'Continúa donde lo dejaste.',
    YourProjects: 'Tus proyectos en curso',
    OpenProject: 'Abrir este proyecto',
    NoProjects: 'No hay proyectos en curso.',
    AppUpdating: 'Actualizando la aplicación…',
    DraftRestored: 'Borrador restaurado',
    SaveExpiredTitle: 'Guardado caducado',
    SaveExpiredMessage: 'Este guardado ha caducado o ya no está disponible.',
    Continue: 'Continuar',
    PhotoFramePickShape: 'Elige un marco',
    PhotoFramePlacePhoto: 'Coloca y ajusta tu foto',
    PhotoFrameChangePhoto: 'Cambiar foto',
    PhotoFrameDropTitle: 'Arrastra una foto aquí',
    PhotoFrameDropSub: 'o haz clic para subir',
    Rotation: 'Rotación',
    Reset: 'Restablecer',
    ProofLogoTitle: 'Logo del BAT',
    ProofLogoUseSite: 'Mantener el logo de {site}',
    ProofLogoUseMine: 'Con mi propio logo',
    ProofLogoUseMineDesc: 'Solo en el BAT, no en los archivos de impresión.',
    ProofLogoNone: 'Sin ningún logo',
    ProofLogoDropTitle: 'Importa tu logo',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'Validando tu pedido',
    LoadingStepScreenshots: 'Generando vistas previas',
    LoadingStepPrintFile: 'Generando archivos de impresión',
    LoadingStepUpload: 'Enviando al servidor',
    LoadingStepSave: 'Guardando la configuración',
    LoadingGraduation: 'Cargando la graduación',
    OptimizingImage: 'Optimizando la imagen',
    LoadingScene: 'Cargando la escena',
    LoadingStepZip: 'Creando el zip',
    LoadingProduct: 'Cargando el producto',
    Category: 'Categoría',
    Product: 'Producto',
    Summary: 'Resumen',
    Zone: 'Zona',
    SelectZone: 'Seleccionar una zona',
    SelectAZone: 'Elegir una zona',
    Undo: 'Deshacer',
    Redo: 'Rehacer',
    Recenter: 'Centrar la vista',
    HelpersIntro: 'Bordes de las zonas, cuadrícula, reglas y guías en el lienzo 2D.',
    ShowZoneBordersHint: 'Marcos de las zonas en el lienzo principal',
    Save: 'Guardar',
    Saving: 'Guardando',
    Grid: 'Cuadrícula',
    SwitchTo3D: 'Cambiar a 3D',
    PrintZone: 'Zona de impresión',
    ViewModeSwitch: 'Modo de visualización',
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Doble',
    ShowZoneBorders: 'Mostrar el contorno de las zonas',
    ShowZoneBordersHelp: 'Muestra/oculta el contorno punteado y la etiqueta de las zonas en el lienzo 2D.',
    ManageElements: 'Gestionar los elementos',
    StartWithTheme: 'Empezar con un tema',
    Customize: 'Personalizar',
    FromThemeLibrary: 'Desde nuestra biblioteca de temas',
    StartFromScratch: 'Empezar desde cero',
    Or: 'o',
    PreviousCreations: 'Creaciones anteriores',
    WithModel: 'Con una plantilla',
    Search: 'Buscar',
    SubCategory: 'Subcategoría',
    Next: 'Siguiente',
    Previous: 'Anterior',
    Validate: 'Validar',
    DownloadMyProject: 'Descargar mi proyecto',
    EditThemeColors: 'Modificar los colores de los elementos',
    AddPattern: 'Añadir un fondo',
    EditGraduation: 'Modificar la graduación',
    Pattern: 'Fondo',
    PatternHint: 'El motivo se repite en toda el área de personalización. Sus colores son personalizables.',
    SearchTheme: 'Buscar un tema (título o etiqueta)',
    Theme: 'Tema',
    Graduation: 'Graduación',
    Graduation_s: 'Graduación(es)',
    ErrorOccurred: 'Se ha producido un error.',
    ReloadPage: 'Vuelva a cargar la página.',
    LoadingCategories: 'Cargando las categorías',
    ShowAll: 'Ver todo',
    Categories: 'Categorías',
    ComingSoon: 'Próximamente',
    DropImageHere: 'Arrastre y suelte una imagen',
    ReleaseToImport: 'Suelte para importar',
    OrClickToBrowse: 'o haga clic para explorar',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        'Este método de impresión funciona con colores definidos. Le recomendamos usar archivos vectorizados para un resultado óptimo.',
    SearchInPhotoGallery: 'Buscar en nuestra galería de fotos',
    QrCode: 'Código QR',
    QrCodeContent: 'Contenido (URL, texto, correo…)',
    QrCodePlaceholder: 'https://ejemplo.com',
    QrCodeForeground: 'Color QR',
    QrCodeBackground: 'Fondo',
    QrCodeTransparentBg: 'Fondo transparente',
    QrCodeErrorLevel: 'Tolerancia a errores',
    QrCodeErrorL: '7 % (densidad baja)',
    QrCodeErrorM: '15 % (estándar)',
    QrCodeErrorQ: '25 %',
    QrCodeErrorH: '30 % (alta)',
    QrCodeEmptyPreview: 'Introduzca un contenido para previsualizar',
    QrCodeRequired: 'El contenido del código QR es obligatorio.',
    QrCodeInvalidUrl: 'Introduzca una URL de código QR válida (http:// o https://).',
    QrCodeAdd: 'Añadir el código QR',
    QrCodeEditOnlyColors:
        'Tras crear un código QR, solo se pueden cambiar los colores. Para cambiar su contenido, elimínelo y cree uno nuevo.',
    ImageQualityGood: 'Buena resolución',
    ImageQualityMedium: 'Resolución media',
    ImageQualityLow: 'Baja resolución: amplíe la imagen o redúzcala en el lienzo',
    LowQualityAlertTitle: 'Atención',
    LowQualityAlertMessage:
        'Su creación contiene imágenes de baja calidad o que se han ampliado demasiado respecto a su resolución original. Debe corregir su creación o aceptar el riesgo de pixelación en la impresión.',
    LowQualityAlertHint: 'Umbral de baja resolución:',
    LowQualityAcceptRisk: 'Acepto el riesgo de pixelación de mis imágenes de baja calidad',
    Preview: 'Vista previa',
    Bold: 'Negrita',
    Italic: 'Cursiva',
    Underline: 'Subrayado',
    FontSize: 'Tamaño',
    SelectFont: 'Elegir una fuente',
    UploadFont: 'Subir mi fuente',
    UploadFontHint: 'TTF u OTF · 5 MB máx.',
    CustomFontBadge: 'propia',
    CustomFontImported: 'Fuente importada.',
    CustomFontFormatError: 'Formato no compatible (solo TTF u OTF).',
    CustomFontTooLarge: 'Fuente demasiado grande (5 MB máximo).',
    CustomFontImportFailed: 'Error al importar la fuente.',
    CustomFontRemoved: 'Fuente eliminada.',
    RecentFonts: 'Recientes',
    Clear: 'Borrar',
    TextColor: 'Color del texto',
    TextOutline: 'Contorno',
    AddOutline: 'Añadir un contorno',
    RemoveOutline: 'Quitar el contorno',
    PickColor: 'Elegir un color',
    PickThemeCategory: 'Elija una categoría para explorar los temas',
    NoThemeInCategory: 'No hay temas en esta categoría',
    ThemePreviewLabel: 'Vista previa del tema',
    PickAnotherTheme: 'Elegir otro tema',
    Keep: 'Conservar',
    LoadingThemes: 'Cargando los temas',
    LoadingPatterns: 'Cargando los fondos',
    EditableThemeColors: 'Colores modificables de los elementos',
    PickAColor: 'Elija un color',
    SelectALayout: 'Seleccione una plantilla',
    CreateLayer: 'Crear un elemento',
    LastDownloads: 'Últimas descargas',
    Cancel: 'Cancelar',
    Back: 'Atrás',
    BackToProvider: 'Volver a {provider}',
    LayerNotFound: 'No se encontró el elemento',
    ChangeImage: 'Cambiar la imagen',
    ChangePattern: 'Cambiar el fondo',
    Resize: 'Redimensionar',
    RemoveBackground: 'Recortar fondo',
    Processing: 'Procesando…',
    AddFilter: 'Añadir un filtro',
    PhotoCredit: 'Foto de {author} en {provider}',
    PhotoBy: 'Foto de',
    On: 'en',
    LinkRedirectionWarning: 'Este enlace le redirigirá a este sitio web',
    LoadMore: 'Cargar más',
    EditLayer: 'Editar el elemento',
    Import: 'Importar',
    FromYourDevice: 'Desde su dispositivo',
    FromImageGallery: 'Desde la galería de imágenes',
    NoGraduationsAvailable: 'No hay graduaciones disponibles',
    Confirm: 'Confirmar',
    CustomizeProduct: 'Personalice su producto',
    WriteYourText: 'Escriba su texto aquí',
    Text: 'Texto',
    Image: 'Imagen',
    DesignSummary: 'Resumen de su diseño',
    AddOptions: 'Añadir opciones',
    TermsOfSale: 'Condiciones generales de venta',
    TOSMessage:
        'Certifico que mi creación cumple con las [Condiciones generales de venta](#) y en particular con el artículo 8 - Propiedad intelectual',
    IValidateMyCreation: 'Valido mi creación',
    FunctionalityNotAvailable: 'Funcionalidad no disponible',
    Lock: 'Bloquear',
    Unlock: 'Desbloquear',
    AddLayer: 'Añadir un elemento',
    LayerSectionTemplates: 'Plantillas',
    LayerSectionText: 'Texto y datos',
    LayerSectionImages: 'Imágenes',
    LayerSectionDecor: 'Decoración',
    LayerSectionTools: 'Herramientas',
    DragLayersToReorder: 'Arrastre las capas para reordenarlas',
    PleaseAgreeTOS: 'Acepte las condiciones generales para validar su creación.',
    ErrorExportPrintFile: 'Se produjo un error al exportar el archivo de impresión.',
    ErrorExportProofFile: 'Se produjo un error al exportar la prueba de impresión.',
    ErrorAddToCart: 'Se produjo un error al añadir al carrito: ',
    Gabarit: 'Plantilla',
    FicheTechnique: 'Ficha técnica',
    GeneratingPrintFile: 'Generando el archivo de impresión…',
    GeneratingProofFile: 'Generando la prueba de impresión…',
    LeaveCustomizer: 'Salir del configurador',
    LeaveManager: 'Salir del gestor de elementos',
    ChangeProductTitle: 'Su creación se borrará.',
    ChangeProductConfirm: 'Cambiar de producto borrará su creación definitivamente, ¿está seguro?',
    Duplicate: 'Duplicar',
    LoadingTheme: 'Cargando el tema',
    LoadingPattern: 'Cargando el fondo',
    Expand: 'Agrandar',
    Shrink: 'Reducir',
    TiltLeft: 'Inclinar a la izquierda',
    TiltRight: 'Inclinar a la derecha',
    Rotate: 'Girar',
    Move: 'Mover',
    Reposition: 'Reposicionar',
    MoveUp: 'Mover hacia arriba',
    MoveDown: 'Mover hacia abajo',
    MoveLeft: 'Mover a la izquierda',
    MoveRight: 'Mover a la derecha',
    NoCustomization: 'No hay personalización en el producto.',
    MissingCustomization: 'Falta personalización',
    SelectGraduation: 'Seleccione una graduación',
    ProofTitle: 'Prueba de impresión',
    ProofDesignTitle: 'Personalización 2D',
    ProofScreenshotsTitle: 'Vistas 3D',
    ProofSelectedInksTitle: 'Colores seleccionados',
    Warning: 'Atención',
    SelectZoneBeforeTheme: 'Seleccione una zona antes de elegir un tema.',
    ThemeTooManyElements: 'El tema contiene demasiados elementos. Elija otro',
    Error: 'Error',
    ProductNotFound: 'Producto no encontrado',
    ProductNotFoundMessage: 'Producto no encontrado, será redirigido a la página de inicio.',
    NoCategoryAvailable: 'No hay categorías disponibles',
    CategoryNotFound: 'Categoría no encontrada',
    CategoryNotFoundMessage: 'Categoría no encontrada, será redirigido a la página de inicio.',
    Unavailable: 'No disponible',
    SavedConfigurations: 'Configuraciones guardadas',
    YourSavedConfigurations: 'Sus configuraciones guardadas',
    NoSavedConfigurations: 'No hay configuraciones guardadas para este producto',
    ConfigurationName: 'Nombre de la configuración',
    Created: 'Creado',
    Expires: 'Caduca',
    Load: 'Cargar',
    ConfirmDeleteConfiguration: '¿Seguro que desea eliminar esta configuración?',
    Close: 'Cerrar',
    Step: 'Paso',
    CustomizeProductDesc: 'Elija cómo empezar: creación libre o a partir de un tema propuesto a continuación.',
    StartFromScratchDesc: 'Un lienzo en blanco para añadir textos, imágenes y formas, sin plantilla impuesta.',
    ChooseProductDesc: 'Elija un producto para personalizar.',
    PrintMethod: 'Método de impresión',
    ChoosePrintMethod: 'Elija su método',
    ChoosePrintMethodDesc:
        'Seleccione el método de impresión para este producto. Esta elección es definitiva para esta personalización.',
    Digital: 'Digital',
    ScreenPrinting: 'Serigrafía',
    LaserEngraving: 'Grabado láser',
    Embroidery: 'Bordado',
    RestrictedToPalette: 'Colores limitados a la paleta',
    ChooseInks: 'Elija sus tintas',
    ChooseThreads: 'Elija sus hilos',
    AppliesToZone: 'Zona: {zone}',
    Ink: 'Tinta',
    Thread: 'Hilo',
    InkOverride: 'Forzar una tinta',
    ThreadOverride: 'Forzar un hilo',
    SuggestInks: 'Tintas sugeridas',
    SuggestThreads: 'Hilos sugeridos',
    RecommendColorsFromImage: 'Recomendar colores a partir de la imagen',
    NoColorSuggestion: 'No hay sugerencia de color para esta imagen.',
    InkAssistantHelp: 'Este método utiliza una paleta de {count} colores fijos.',
    InkAssistantQuestion: '¿Cómo desea definir sus colores?',
    InkAssistantUpload: 'Ayúdame a encontrar mis colores',
    InkAssistantUploadDesc:
        'Importe su imagen, logotipo o motivo: detectamos automáticamente los colores de la paleta más cercanos.',
    InkAssistantManual: 'Elijo mis colores manualmente',
    InkAssistantManualDesc: 'Seleccione cada color, uno a uno, en la paleta.',
    InkAssistantAnalyzing: 'Analizando su imagen…',
    InkChoiceModifiableHint: 'Esta elección se puede modificar en cualquier momento.',
    InkAssistantResultDesc: 'Estos son los colores de la paleta más cercanos a su imagen.',
    InkDuplicateWarning:
        'Este color ya está seleccionado para otra tinta / hilo. Seleccionarlo por segunda vez fusionará los colores definitivamente. ¿Está seguro?',
    Selected: 'Seleccionado',
    VectorizeImage: 'Vectorizar la imagen',
    Vectorizing: 'Vectorizando…',
    VectorizePreviewTitle: 'Resultado de la vectorización',
    VectorizeIntro:
        'La imagen se convertirá en vector y se limitará a las tintas elegidas. Valide el resultado para aplicarlo.',
    VectorizeApply: 'Aplicar el vector',
    VectorizeConsent:
        'Entiendo que soy responsable de controlar el resultado de la vectorización y que la impresión reflejará dicho resultado.',
    VectorizeThreshold: 'Umbral (detalle / fondo)',
    VectorizeThresholdHint:
        'Ajuste el umbral para afinar: más bajo elimina más fondo claro (line-art); más alto conserva más zonas claras.',
    VectorizeCancel: 'Cancelar',
    VectorizeFailed: 'La vectorización ha fallado. Vuelva a intentarlo o cambie de imagen.',
    Before: 'Antes',
    After: 'Después',
    VariableText: 'Texto variable',
    VariableTextIntro:
        'Esta función se parece a un mailing y le permite obtener su producto impreso en un ejemplar único por cada texto; la cantidad se calcula automáticamente para su carrito.',
    VariableTextData: 'Datos (una línea = un ejemplar)',
    VariableTextPlaceholder: 'Jean Dupont\nMarie Martin\nPaul Bernard',
    VariableTextImport: 'Importar un CSV / Excel',
    SessionImages: 'Imágenes importadas',
    Accept: 'Aceptar',
    UploadConsentMessage:
        'Confirmo que ninguno de mis archivos infringe las leyes vigentes, los derechos de autor o los derechos de terceros.',
    VariableTextNoData: 'Añada al menos una línea para previsualizar.',
    VdpFields: 'Campos variables',
    VdpFieldName: 'Nombre del campo',
    VdpPlace: 'Colocar',
    VdpPlaced: 'Colocado',
    VdpAddField: 'Añadir un campo',
    VdpAddRow: 'Añadir una línea',
    VdpLine: 'Fila',
    VdpEnterData: 'Introducir mis datos',
    Done: 'Hecho',
    VdpFieldStyle: 'Estilo del campo',
    VdpFirstRowHeader: '1.ª línea = encabezado (nombres de los campos)',
    VdpQuantity: 'Cantidad: {qty}',
    VdpQuantityHint: 'La cantidad viene impuesta por el número de líneas de su texto variable.',
    VariableTextOnlyOne: 'Un solo campo de texto variable por creación.',
    VariableTextEmptyFile: 'Archivo vacío o sin columna utilizable.',
    VariableTextImportError: 'No se puede leer este archivo. Use un CSV o pegue el texto.',
    VariableTextExcelUnavailable: 'Lectura de Excel no disponible. Exporte a CSV o pegue el texto.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks: 'Tintas seleccionadas: {chosen}/{required}. Elija todas las tintas antes de validar.',
    PreflightScreenColorCount: 'Serigrafía: su creación está limitada a {count} tinta(s).',
    PreflightMinStroke: 'Grosor mínimo de trazo recomendado: {mm} mm. Los trazos más finos pueden imprimirse mal.',
    PreflightMinFont: 'Tamaño de fuente mínimo recomendado: {pt} pt.',
    PreflightLaserMonochrome: 'Grabado láser: el resultado final será monocromo.',
    More: 'Más',
    All: 'Todos',
    AllCategories: 'Todas las categorías',
    SearchCategory: 'Buscar una categoría…',
    NoProductAvailable: 'No hay productos en esta categoría.',
    ChooseProductTitle: 'Elige tu producto para personalizar',
    PrintMethodQuestion: '¿Cómo quieres imprimir tu {product}?',
    PrintMethodIntro:
        'Cada método tiene sus ventajas y limitaciones: define los colores y acabados disponibles después.',
    StartLabel: 'Punto de partida',
    StartTitle: 'Empieza con un tema o una página en blanco',
    StartIntro: 'Un tema = un diseño listo para retocar (lo más rápido). Página en blanco = control total.',
    StepProduct: 'Producto',
    StepMethod: 'Método',
    StepStart: 'Inicio',
    StepDesign: 'Diseño',
    ChangeTheme: 'Cambiar de tema',
    BackToTheme: 'Volver al tema',
    Recent: 'Recientes',
    WhiteNotPrintable: 'El blanco no se puede imprimir (transparente).',
    LoginToSave: 'Inicia sesión para encontrar tus diseños en tu cuenta.',
    Login: 'Iniciar sesión',
    LoggingIn: 'Iniciando sesión…',
    ContinueWithoutAccount: 'Continuar sin cuenta',
    SaveEmailPlaceholder: 'Tu dirección de correo electrónico',
    SaveEmailHint: 'Recibirás un enlace para retomar tu proyecto (guardado 30 días).',
    SaveConfirmTitle: 'Proyecto guardado',
    SaveConfirmMessage: 'Tu proyecto se ha guardado. Acabamos de enviarte un correo con el enlace para retomarlo.',
    DisableEmbroideryEffect: 'Desactivar efecto bordado',
    AddThread: 'Añadir un hilo',
    RemoveThread: 'Quitar un hilo',
    VectorizeDenoise: 'Reducir el ruido',
    VectorizeDenoiseHint: 'Elimina manchas y pequeños puntos parásitos.',
    VectorizeSmoothing: 'Suavizado',
    VectorizeSmoothingHint: 'Redondea los contornos (menos ángulos).',
    ZoomIn: 'Acercar',
    ZoomOut: 'Alejar',
    Fit: 'Ajustar',
    Apply: 'Aplicar',
    Edit: 'Editar',
    Support: 'Soporte',
    VectorizeAcknowledge:
        'Entiendo que soy responsable de verificar el resultado de la vectorización y que la impresión lo reflejará.',
    Crop: 'Recortar',
    Font: 'Fuente',
    Style: 'Estilo',
    Outline: 'Contorno',
    Steps: 'Pasos',
    Tools: 'Herramientas',
    ThemeColors: 'Colores',
    Minimize: 'Minimizar',
    MoveLayerUp: 'Subir la capa',
    MoveLayerDown: 'Bajar la capa',
    DragLayer: 'Arrastra para reordenar',
    NoResult: 'Sin resultados',
    SearchElement: 'Buscar un elemento…',
    ExpertMode: 'Modo experto',
    Finish: 'Finalizar',
    ChooseImageOrPhoto: 'Elegir una imagen o foto',
    WizardIntro: 'Sigue los pasos para una creación personalizada en 1 minuto.',
    WizardIntroExpert: '¿Quieres más libertad? Cambia al modo experto.',
    ClickToChooseImage: 'Haz clic aquí para elegir una imagen o foto',
    ChooseCategoryDesc: 'Selecciona una familia de productos para empezar.',
    SelectProductDesc: 'Selecciona un producto para empezar…',
    FinalReview: 'Último paso',
    StartWithThemeDesc: 'Empieza con un diseño preconfigurado.',
    WithModelDesc: 'Elige una plantilla ya hecha.',
    ExpertModeConfirmTitle: 'Modo experto',
    ExpertModeConfirmMsg:
        'Cambiar al modo experto es una decisión definitiva. Este modo es un poco más complejo de usar, pero te permite añadir y modificar elementos sin restricciones.',
    ExpertModeHint: 'Completa tu diseño sin límites: añade textos y fotos como quieras.',
    VariableData: 'Datos variables',
    PhotoFrame: 'Marco de foto',
    PhotoFrameHint: 'Elige una forma y luego coloca una foto dentro.',
    PhotoFrameChooseShape: '1. Forma del marco',
    PhotoFrameChangeShape: 'Cambiar de forma',
    PhotoFramePickPhoto: 'Elegir una foto',
    FromLibrary: 'Desde la biblioteca',
    VdpMaxRowsReached: 'Stock máximo alcanzado',
    VdpImportTruncated: 'Importación limitada al stock disponible',
    LetterSpacing: 'Espaciado entre letras',
    OutlineActive: 'Contorno activado',
    OutlineThickness: 'Grosor del contorno',
    AlignLeft: 'Alinear a la izquierda',
    AlignCenter: 'Centrar',
    AlignRight: 'Alinear a la derecha',
    Uppercase: 'Mayúsculas',
    TextFormatting: 'Formato',
    FontSizeLabel: 'Tamaño de fuente',
    SelectionActions: 'Acciones de selección',
    DragToMove: 'Arrastra para mover',
    DragToResize: 'Arrastra para redimensionar',
    DragToRotate: 'Arrastra para girar',
    MoveUpOneLevel: 'Subir un nivel',
    MoveDownOneLevel: 'Bajar un nivel',
    BringToFront: 'Traer al frente',
    Front: 'Primer plano',
    SendToBack: 'Enviar al fondo',
    BackgroundNeverUnderPattern: 'Fondo (nunca bajo un patrón de fondo)',
    EyedropperColor: 'Cuentagotas de color',
    PresetColors: 'Colores predefinidos',
    RecentColors: 'Colores recientes',
    Palette: 'Paleta',
    HexValue: 'Valor hexadecimal',
    AiResultsHint: 'Encuentra todas las sugerencias en la pestaña Imagen',
    Notifications: 'Notificaciones',
    Zoom: 'Zoom',
    GuidedCustomization: 'Personalización guiada',
    Actions: 'Acciones',
    InkAssistantYourChoice: 'Has elegido:',
    InkAssistantCorrectQuestion: '¿Deseas corregir esta elección?',
    ZonePrices: 'Precio por zona',
    ZonePriceApplied: 'Aplicado',
    ZonePriceUncovered: 'Ninguna opción cubre todas las zonas decoradas.',
    ZonePricesShow: 'Mostrar',
    ZonePricesHide: 'Ocultar',
    '': ''
};
